var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIconDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 60,
    viewBox: "0 0 34 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 28C11.8807 28 13 26.8807 13 25.5C13 24.1193 11.8807 23 10.5 23C9.11929 23 8 24.1193 8 25.5C8 26.8807 9.11929 28 10.5 28Z",
    fill: "#080A54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 28C24.8807 28 26 26.8807 26 25.5C26 24.1193 24.8807 23 23.5 23C22.1193 23 21 24.1193 21 25.5C21 26.8807 22.1193 28 23.5 28Z",
    fill: "#080A54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 21H10C9.499 21 9.075 20.629 9.009 20.132L7.125 6H4V4H8C8.501 4 8.925 4.371 8.991 4.868L9.542 9H27C27.316 9 27.614 9.149 27.802 9.403C27.991 9.657 28.049 9.985 27.958 10.287L24.958 20.287C24.831 20.71 24.441 21 24 21Z",
    fill: "#080A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIconDesktop);
export default __webpack_public_path__ + "static/media/cart-icon-desktop.05e7a311851a373917e6aff56b8ccb60.svg";
export { ForwardRef as ReactComponent };